




















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {BvTableFieldArray} from 'bootstrap-vue';
import {ConvertModule, ILocation, ISales, TInterval} from '@/stores/modules/convert';
import {WebService} from '@/services/web.service';
import moment from 'moment-timezone';
import { sortBy, filter } from 'lodash';

@Component
export default class LocationSalesTable extends Vue {
	@Prop() private location!: ILocation | null;

	public selectedInterval: TInterval = 'month';
	private intervals: {
		[key: string]: {
			limit: number | null;
			startOf: string;
			format: string;
		}
	} = {
		hour: {
			limit: 0,
			startOf: 'day',
			format: 'ha'
		},
		day: {
			limit: 30,
			startOf: 'day',
			format: 'M/D'
		},
		week: {
			limit: 4,
			startOf: 'isoWeek',
			format: '[Week] W'
		},
		month: {
			limit: 12,
			startOf: 'month',
			format: 'MMM'
		},
		year: {
			limit: null,
			startOf: 'year',
			format: 'YYYY'
		}
	};

	public fields: BvTableFieldArray = [
		{
			key: 'timestamp',
			label: 'Date',
		},
		{
			key: 'redemptions',
			label: 'Redemptions',
		},
		{
			key: 'gross',
			label: 'Gross Sales',
			formatter: 'formatMoney'
		},
		{
			key: 'net',
			label: 'Net Sales',
			formatter: 'formatMoney'
		}
	];

	get items(): ISales[] {
		let items = sortBy(this.getSalesByInterval(this.selectedInterval), 'timestamp').reverse();
		// Let's remove the data that hasn't happened yet
		if(this.selectedInterval === 'hour') {
			const currentHour = moment().hour();
			items = filter(items, (item) => {
				return moment.unix(item.timestamp).tz('UTC').hour() <= currentHour;
			});
		}
		return items;
	}

	get locationBase(): string | null {
		return this.location === null ? null : this.location.base;
	}

	get totalSales() {
		return ConvertModule.totalSalesByLocationBase(this.locationBase);
	}

	get dateFormat(): string {
		return this.intervals[this.selectedInterval].format;
	}

	@Watch('location')
	onLocationChange() {
		this.fetchSales(this.selectedInterval);
	}

	async mounted() {
		this.fetchSales(this.selectedInterval);
	}

	async fetchSales(interval: TInterval) {
		const dateFormat = 'YYYY-MM-DD';
		let startDate = null;
		if(this.intervals[interval].limit !== null) {
			startDate = moment().startOf(this.intervals[interval].startOf).subtract(this.intervals[interval].limit, interval).format(dateFormat);
		}
		const endDate = moment().format(dateFormat);
		await WebService.getSales(this.locationBase, interval, startDate, endDate);
		await WebService.getTotalSales(this.locationBase);
	}

	async selectInterval(interval: TInterval) {
		this.fetchSales(interval);
		this.selectedInterval = interval;
	}

	getSalesByInterval(interval: TInterval) {
		return ConvertModule.salesByLocationBaseAndInterval(this.locationBase, interval);
	}

	public reduceColumn(columnName: 'redemptions' | 'gross' | 'net') {
		return this.items.reduce((total, item) => {
			return total += item[columnName];
		}, 0);
	}
}
